import { render, staticRenderFns } from "./showTeacherList.vue?vue&type=template&id=b31e01a2&scoped=true&"
import script from "./showTeacherList.vue?vue&type=script&lang=js&"
export * from "./showTeacherList.vue?vue&type=script&lang=js&"
import style0 from "./showTeacherList.vue?vue&type=style&index=0&id=b31e01a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b31e01a2",
  null
  
)

export default component.exports